import { Pipe, PipeTransform } from '@angular/core';
import { parseMessageContent, ParsedMessageContent } from './attachment-markers';

/**
 * Pure pipe wrapper around `parseMessageContent`.
 *
 * Calling `parseMessageContent(message.content)` directly in a template returns a NEW
 * object (and a new `attachmentRefs` array) on every change-detection pass. That makes
 * `<app-message-attachments [attachments]>` see a changed @Input every cycle, firing its
 * `ngOnChanges` → async blob load → another CD pass → infinite loop (frozen tab).
 *
 * A pure pipe memoizes on the input reference, so a stable `content` string yields the
 * exact same parsed object every cycle and the child stops re-loading.
 */
@Pipe({
  name: 'parseMessageContent',
})
export class ParseMessageContentPipe implements PipeTransform {
  transform(content: string | null | undefined): ParsedMessageContent {
    return parseMessageContent(content ?? '');
  }
}
